export const getProductTitle = (product, language, options = {}) => {
  if (product.hide_title && !options.forceGetTitle) {
    return ''
  }
  switch (language) {
    case 0:
      return product.title_pt
    case 1:
      return product.title_en ? product.title_en : product.title_pt
    case 2:
      return product.title_es ? product.title_es : product.title_pt
    default:
      return ''
  }
}

export const getProductDescription = (product, language) => {
  switch (language) {
    case 0:
      return product.description_pt
    case 1:
      return product.description_en ? product.description_en : product.description_pt
    case 2:
      return product.description_es ? product.description_es : product.description_pt
    default:
      return ''
  }
}

export const isTextFieldEmpty = (textField) => {
  if (!textField || textField === '') return true
  return false
}

export const getProductCategory = (categoryName) => {
  switch (categoryName) {
    case 'maquiagem':
      return 'make_up'
    case 'cabelo':
      return 'hair'
    case 'looks':
      return 'look'
    case 'acessorios':
      return 'accessory'
    default:
      return ''
  }
}



// WEBPACK FOOTER //
// ./src/services/ColoringProductsHelpers.js